<template>
  <main id="_tlqn_admin_page" class="fit column no-wrap">
    <header class="full-width" style="height: 60px; flex-shrink: 0">
      <AdminHeader />
    </header>
    <router-view
      style="max-height: calc(100% - 60px)"
      class="full-width col-grow"
    ></router-view>
  </main>
</template>

<script>
import { getUserProfile } from "../../api/endpoints/auth/getUserProfile";
export default {
  components: {
    AdminHeader: () => import("./Header"),
  },
  async beforeRouteEnter(to, from, next) {
    const profile = await getUserProfile(true);
    if (!profile.roles.some((role) => role.value == "005")) {
      next();
      return;
    }
    console.log(`Enter ${to.name} Guard`);
    if (
      [
        "admin_sample_group",
        "feedback",
        "admin_user_group",
        "sample_distribution",
      ].indexOf(to.name) > -1
    ) {
      next({ name: "admin_quality" });
      return;
    }
    next();
  },
};
</script>
